import { useContext } from 'react';
import LifeReinsurersRowData from './LifeReinsurersRowData';
import { RatioFormat, DollarFormat, TextFormat } from '../../format';
import styles from './ReinsurersRow.module.css';
import AppContext from '../../../AppContext';
import RowHelmet from '../RowHelmet';
import EnhancedProfilesLink from '../../links/EnhancedProfilesLink';
import ISiteLink from '../../links/ISiteLink';

function rowClassSwitch(rowClass: string = '') {
  if (rowClass === 'TOTAL') {
    return styles.total;
  } else {
    return '';
  }
}

export default function LifeReinsurersRow({
  rowKey,
  rowClass,
  label,
  benchmark,
  cocode,
  amount,
  modcoAmount,
  percentOfTotal,
  domicile,
  affiliated,
  groupCode,
  sectionKey
}: LifeReinsurersRowData) {
  const { showBenchmark, year } = useContext(AppContext);

  return (
    <div
      id={sectionKey ? sectionKey + '-' + rowKey : 'rowKey-' + rowKey}
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse} ${rowClassSwitch(
        rowClass
      )}`}>
      <RowHelmet label={label} rowKey={rowKey} benchmarkText={benchmark} />
      <TextFormat textValue={affiliated} />
      <p className="column_align_right">
        <EnhancedProfilesLink cocode={cocode} year={year} />
      </p>
      <p className="column_align_right">
        <ISiteLink
          relativeUrl={`/common/GroupList?year=${year}&grpcode=${groupCode}`}
          label={groupCode}
        />
      </p>
      <TextFormat textValue={domicile} />
      <DollarFormat {...amount} />
      <DollarFormat {...modcoAmount} />
      <RatioFormat {...percentOfTotal} />
      <p></p>
      <p></p>
    </div>
  );
}
